import { VacantRentalObject } from './vacant-rental-object';

export class VacantOtherRentalObject extends VacantRentalObject {
  constructor() {
    super();
  }
}
